'use client'

import { AnimatePresence, motion } from 'framer-motion'
import Image from 'next/image'
import { useTranslations } from 'next-intl'
import { useState } from 'react'
import { SliderNavigation } from '@/components/sliderNavigation'

const TESTIMONIALS = {
    0: {
        imageSrc: '/_images/become-a-partner/testimonials/hempies-vegan.jpg',
        translationKey: 'sectionOne',
    },
    1: {
        imageSrc: '/_images/become-a-partner/testimonials/peter-pane.jpg',
        translationKey: 'sectionTwo',
    },
    2: {
        imageSrc: '/_images/become-a-partner/testimonials/cafe-lemberg.jpg',
        translationKey: 'sectionThree',
    },
    3: {
        imageSrc: '/_images/become-a-partner/testimonials/erra-bar.jpg',
        translationKey: 'sectionFour',
    },
}

export const BecomeAPartnerTestimonials = () => {
    const t = useTranslations('becomeAPartner')

    const [testimonialIndex, setTestimonialIndex] = useState(0)

    const testimonial = TESTIMONIALS[testimonialIndex as 0 | 1 | 2 | 3]

    return (
        <AnimatePresence mode="wait">
            <div className="mb-16 md:mb-[100px] bg-[#08180F] -mx-4 md:-mx-[50px] px-4 py-12 md:px-[50px] md:py-16">
                <div className="flex flex-col items-center max-w-[1000px] mr-auto ml-auto md:flex-row-reverse md:gap-6 md:items-stretch md:justify-between">
                    <motion.div
                        className="md:w-[50%] mb-8 md:mb-0 "
                        key={testimonialIndex}
                        initial={{ opacity: 0, filter: 'brightness(0.9)' }}
                        animate={{ opacity: 1, filter: 'brightness(1)' }}
                        exit={{ opacity: 0, filter: 'brightness(0.9)' }}
                        transition={{ duration: 0.45, ease: 'easeOut' }}
                    >
                        <Image
                            height={1599}
                            width={2000}
                            alt="Smiling cook"
                            src={testimonial.imageSrc}
                            key="smiling-cook"
                            className="object-cover rounded-[20px] max-w-[450px] h-[300px] w-full md:h-[420px]"
                        />
                    </motion.div>

                    <div className="flex flex-col items-center md:items-start md:justify-between w-full md:w-[50%]">
                        <h2 className="text-white text-[32px] leading-9 mb-8 text-center md:text-left max-w-[550px]">
                            {t('testimonials.title')}
                        </h2>

                        <div className="flex flex-col items-center md:items-start">
                            <div className="bg-[#FFC86A] mb-3 w-fit items-center font-semibold text-[12px]  flex gap-1.5 px-3 py-2 rounded-3xl">
                                <p>@</p>

                                <motion.div
                                    key={testimonialIndex}
                                    initial={{ opacity: 0, filter: 'brightness(0.9)' }}
                                    animate={{ opacity: 1, filter: 'brightness(1)' }}
                                    exit={{ opacity: 0, filter: 'brightness(0.9)' }}
                                    transition={{ duration: 0.45, ease: 'easeOut' }}
                                >
                                    <p> {t(`testimonials.${testimonial.translationKey}.title`)}</p>
                                </motion.div>
                            </div>

                            <motion.div
                                key={testimonialIndex}
                                initial={{ opacity: 0, filter: 'brightness(0.9)' }}
                                animate={{ opacity: 1, filter: 'brightness(1)' }}
                                exit={{ opacity: 0, filter: 'brightness(0.9)' }}
                                transition={{ duration: 0.45, ease: 'easeOut' }}
                            >
                                <p className="h-[140px] font-medium text-white text-center md:text-left mb-8 max-w-[450px]">
                                    {t(`testimonials.${testimonial.translationKey}.description`)}
                                </p>
                            </motion.div>

                            <SliderNavigation
                                onChange={setTestimonialIndex}
                                activeIndex={testimonialIndex}
                                total={4}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </AnimatePresence>
    )
}
